/**
 * Layer, used for bit operations.
 */
export enum Layer {
  /** Layer 0. */
  Layer0 = 0x1,
  /** Layer 1. */
  Layer1 = 0x2,
  /** Layer 2. */
  Layer2 = 0x4,
  /** Layer 3. */
  Layer3 = 0x8,
  /** Layer 4. */
  Layer4 = 0x10,
  /** Layer 5. */
  Layer5 = 0x20,
  /** Layer 6. */
  Layer6 = 0x40,
  /** Layer 7. */
  Layer7 = 0x80,
  /** Layer 8. */
  Layer8 = 0x100,
  /** Layer 9. */
  Layer9 = 0x200,
  /** Layer 10. */
  Layer10 = 0x400,
  /** Layer 11. */
  Layer11 = 0x800,
  /** Layer 12. */
  Layer12 = 0x1000,
  /** Layer 13. */
  Layer13 = 0x2000,
  /** Layer 14. */
  Layer14 = 0x4000,
  /** Layer 15. */
  Layer15 = 0x8000,
  /** Layer 16. */
  Layer16 = 0x10000,
  /** Layer 17. */
  Layer17 = 0x20000,
  /** Layer 18. */
  Layer18 = 0x40000,
  /** Layer 19. */
  Layer19 = 0x80000,
  /** Layer 20. */
  Layer20 = 0x100000,
  /** Layer 21. */
  Layer21 = 0x200000,
  /** Layer 22. */
  Layer22 = 0x400000,
  /** Layer 23. */
  Layer23 = 0x800000,
  /** Layer 24. */
  Layer24 = 0x1000000,
  /** Layer 25. */
  Layer25 = 0x2000000,
  /** Layer 26. */
  Layer26 = 0x4000000,
  /** Layer 27. */
  Layer27 = 0x8000000,
  /** Layer 28. */
  Layer28 = 0x10000000,
  /** Layer 29. */
  Layer29 = 0x20000000,
  /** Layer 30. */
  Layer30 = 0x40000000,
  /** Layer 31. */
  Layer31 = 0x80000000,
  /** All layers. */
  Everything = 0xffffffff,
  /** None layer. */
  Nothing = 0x0
}
